export const ACTIVATION_LOADING_MIN_DURATION_MS = 3500;

export const ABOUT_CIRCLE_V4_PATH = "/eclipse";
export const OPT_IN_BAR_DISMISSED_AT_LS_KEY =
  "circle-v4-opt-in-bar-dismissed-at";
export const OPT_IN_BAR_ECLIPSE_APPROACH_DAYS = 3;
export const ECLIPSE_DATE = new Date("2026-06-16T04:00:00.000Z"); // June 16, midnight ET (EDT)
export const ECLIPSE_KEYNOTE_START = new Date("2026-06-16T16:55:00.000Z"); // June 16, 12:55 pm ET (EDT) — Eclipse announced
export const ECLIPSE_KEYNOTE_END = new Date("2026-06-16T18:00:00.000Z"); // June 16, 2:00 pm ET (EDT) — live phase ends

export const isKeynoteLive = (): boolean => {
  const now = new Date();
  return now >= ECLIPSE_KEYNOTE_START && now < ECLIPSE_KEYNOTE_END;
};

export const isFromEclipseMidnightToKeynoteStart = (): boolean => {
  const now = new Date();
  return now >= ECLIPSE_DATE && now < ECLIPSE_KEYNOTE_START;
};

export const isPostKeynote = (): boolean => new Date() >= ECLIPSE_KEYNOTE_END;

export const isOptInBarDismissible = (): boolean => !isKeynoteLive();

export const ECLIPSE_TRIAL_END_DATE = new Date("2026-07-31T00:00:00Z"); // 31st July 2026
export const ECLIPSE_PAGE_BACKGROUND = "#08091A";
export const ECLIPSE_ANNOUNCEMENT_CARD_BACKGROUND = "#1e1e20";
export const CIRCLE_BASE_URL = "https://circle.so";
export const ECLIPSE_MARKETING_URL = `${CIRCLE_BASE_URL}/eclipse`;
export const ECLIPSE_RELEASE_URL = `${CIRCLE_BASE_URL}/eclipse-release`;
export const ECLIPSE_MARKETING_PAGE_UTM_PARAMS = {
  utm_source: "marketing",
  utm_medium: "product",
  utm_campaign: "eclipse-pmm-reveal",
  utm_content: "in-app-banner-2",
};
export const ECLIPSE_MARKETING_URL_WITH_UTM_PARAMS = `${ECLIPSE_MARKETING_URL}?${new URLSearchParams(ECLIPSE_MARKETING_PAGE_UTM_PARAMS).toString()}`;
export const ECLIPSE_CTA_CLICKED_EVENT = "eclipse:cta_clicked";
export const ECLIPSE_KEYNOTE_VIDEO_URL =
  "https://vz-da4db2af-583.b-cdn.net/dc69fda8-cba1-4ca1-93ad-bcf3095cde02/playlist.m3u8";
